import { InputItem } from "../data";

export const WireTransferSteps = [
  { path: "recipient-details-wire-transfer", label: "Recipient Details" },
  { path: "business-details", label: "Business Details" },
  { path: "payment-details-wire-transfer", label: "Payment Details" },
  { path: "schedule-transfer", label: "Schedule Transfer" },
  { path: "summary", label: "Summary" },
  { path: "confirmation", label: "Confirmation" },
];

export const wireTransferInputs: InputItem[] = [
  {
    name: "RecipientLegalName",
    type: "text",
    label: "Recipient's Legal Name",
    placeholder: "",
    hasTransactionFee: false,
    hasBeneficiary: false,
    accountName: false,
  },
  {
    name: "RecipientType",
    type: "text",
    label: "Recipient's Type",
    placeholder: "",
    hasTransactionFee: false,
    hasBeneficiary: false,
    accountName: false,
  },
  {
    name: "RecipientProfession",
    type: "text",
    label: "Recipient's Profession",
    placeholder: "",
    hasTransactionFee: false,
    hasBeneficiary: false,
    accountName: false,
  },
  {
    name: "RecipientPhoneNumber",
    type: "text",
    label: "Recipient's Phone Number",
    placeholder: "",
    hasTransactionFee: false,
    hasBeneficiary: false,
    accountName: false,
  },
  {
    name: "RecipientCountry",
    type: "text",
    label: "Recipient's Country",
    placeholder: "",
    hasTransactionFee: false,
    hasBeneficiary: false,
    accountName: false,
  },
  {
    name: "RecipientAddress",
    type: "text",
    label: "Recipient's Address",
    placeholder: "",
    hasTransactionFee: false,
    hasBeneficiary: false,
    accountName: false,
  },
  {
    name: "RecipientState",
    type: "text",
    label: "Recipient's State",
    placeholder: "",
    hasTransactionFee: false,
    hasBeneficiary: false,
    accountName: false,
  },
  {
    name: "RecipientCity",
    type: "text",
    label: "Recipient's City",
    placeholder: "",
    hasTransactionFee: false,
    hasBeneficiary: false,
    accountName: false,
  },
];

export const recipientType = [
  {
    label: "Personal",
    value: "personal",
  },
  {
    label: "Business",
    value: "business",
  },
];
export const recipientProfessions: string[] = [
  "Employer",
  "Landlord",
  "Contractor",
  "Transferring to Subsidiary",
  "Vendor",
  "Others",
];
export const recipientStates: string[] = [
  "Alabama",
  "Alaska",
  "Arizona",
  "Arkansas",
  "California",
  "Colorado",
  "Connecticut",
  "Delaware",
  "Florida",
  "Georgia",
];

export const recipientCities: string[] = [
  "New York City",
  "Los Angeles",
  "Chicago",
  "Houston",
  "Phoenix",
  "Philadelphia",
  "San Antonio",
  "San Diego",
];

export const businessDetailsInputs: InputItem[] = [
  {
    name: "Website",
    type: "url",
    label: "Add a website or LinkedIn profile for the recipient (If available)",
    placeholder: "www.example.com/linkedinprofile",
    hasTransactionFee: false,
    hasBeneficiary: false,
    accountName: false,
    hasIcon: false,
  },
  {
    name: "GoodsType",
    type: "text",
    label: "What specific goods or services did you receive?",
    placeholder: "",
    hasTransactionFee: false,
    hasBeneficiary: false,
    accountName: false,
    hasIcon: false,
  },
  {
    name: "SupportingDoc",
    type: "file",
    label: "Attach invoices, contracts or any supporting document",
    placeholder: "Choose file (PDF/JPG/PNG)",
    hasTransactionFee: false,
    hasBeneficiary: false,
    accountName: false,
    hasIcon: true,
  },
  {
    name: "Memo",
    type: "text",
    label: "Memo for the recipient",
    placeholder: "",
    hasTransactionFee: false,
    hasBeneficiary: false,
    accountName: false,
    hasIcon: false,
  },
];

export const paymentDetailsInput: InputItem[] = [
  {
    name: "RecipientSwiftCode",
    type: "text",
    label: "Recipient’s bank swift code",
    placeholder: "",
  },
  {
    name: "RecipientIBAN",
    type: "text",
    label: "Recipient’s IBAN",
    placeholder: "",
  },
  {
    name: "Amount",
    type: "number",
    label: "Amount",
    placeholder: "$0.00",
    hasTransactionFee: true,
  },
  {
    name: "Purpose",
    type: "text",
    label: "Purpose of Transaction",
    placeholder: "",
  },
];

export const wireTransferPaymentSummary = [
  {
    title: "Amount sent",
    key: "Amount",
  },
  {
    title: "Recipient Name",
    key: "RecipientLegalName",
  },
  {
    title: "Recipient's Phone Number",
    key: "RecipientPhoneNumber",
  },
  {
    title: "Recipient’s bank swift code",
    key: "RecipientSwiftCode",
  },
  {
    title: "Recipient’s IBAN",
    key: "RecipientIBAN",
  },
  {
    title: "Recipient's State",
    key: "RecipientState",
  },
  {
    title: "Recipient's City",
    key: "RecipientCity",
  },
  {
    title: "Transaction fee",
    key: "TransactionFee",
  },
  {
    title: "Transaction type",
    key: "TransactionType",
  },
  {
    title: "Schedule Transfer",
    key: "period",
  },
  {
    title: "Purpose",
    key: "Purpose",
  },
];
